import { React, useState } from "react";
import { useNavigate } from "react-router-dom"; // near the top
import "animate.css";
import {
	Box,
	Typography,
	Stack,
	Container,
	useMediaQuery,
	useTheme,
	TextField,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import AuthDialog from "./authDialog";

function Auth(props) {
	const navigate = useNavigate(); // inside component
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

	//const [title, setTitle] = useState("");
	const [loading, setLoading] = useState(false);
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [openDialog, setOpenDialog] = useState(false);
	const [reslutMessage, setResultMessage] = useState("");
	const [resultTitle, setResultTitle] = useState("");
	const [createUser, setCreateUser] = useState(false);

	function handleOpenDialog() {
		setOpenDialog(true);
	}

	function handleDialogClose() {
		setOpenDialog(false);
	}

	/*const getRandomPageCB = async () => {
		setLoading(true);
		try {
			const res = await fetch(
				"https://us-central1-mealplanner-f6b88.cloudfunctions.net/api/random-notion-page"
			);
			const data = await res.json();
			if (res.ok) {
				setTitle(data.title);
			} else {
				setTitle("Error: " + data.error);
			}
		} catch (err) {
			setTitle("Error fetching page");
		} finally {
			setLoading(false);
		}
	};
*/
	const checkAuth = async (sendEmail) => {
		setLoading(true);
		try {
			const res = await fetch(
				`https://us-central1-mealplanner-f6b88.cloudfunctions.net/api/check-auth?email=${sendEmail}`
			);
			const data = await res.json();

			if (res.status === 404) {
				// Show special dialog case or button
				setResultMessage(data.message);
				setResultTitle(data.title);
				setCreateUser(true); // <-- if you're using this to trigger UI
			} else if (res.ok) {
				setResultMessage(data.message);
				setResultTitle(data.title);
				setCreateUser(false);
				localStorage.setItem("userEmail", sendEmail);
				localStorage.setItem("token", sendEmail);

				navigate("/mealPlanner"); // <-- replace with your route
			} else {
				setResultMessage(data.message || "Access check failed");
				setResultTitle(data.title);
				setCreateUser(false);
			}
		} catch (err) {
			console.error(err);
			setResultMessage("Something went wrong.");
			setCreateUser(false);
		} finally {
			setLoading(false);
			handleOpenDialog();
		}
	};

	return (
		<div className="Landing animate__animated animate__fadeIn animate__slow">
			<Container>
				<Box
					className="Landing-heading"
					sx={{
						textAlign: { xs: "center", md: "center" },
						paddingTop: { xs: 5 },
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						//justifyContent: "center",
					}}
				>
					<Typography
						variant="h2"
						className="colorText"
						sx={{
							fontSize: { xs: "2rem", md: "3rem" },
							fontWeight: "bold",
							color: "#333",
							mb: 2,
						}}
					>
						<span className={isMobile ? "colorText" : "colorText"}>Meal</span> Planner
					</Typography>
					<Box className="Landing-heading" alignItems="center" justifyItems="center">
						<form
							onSubmit={(event) => {
								event.preventDefault();
								const formData = new FormData(event.currentTarget);
								const formJson = Object.fromEntries(formData.entries());
								alert(JSON.stringify(formJson));
							}}
						>
							<Stack spacing={1} width={isMobile ? "250px" : "300px"}>
								<TextField
									value={name}
									onChange={(event) => {
										setName(event.target.value);
									}}
									label="Name"
									placeholder="Name"
								/>
								<TextField
									value={email}
									onChange={(event) => {
										setEmail(event.target.value);
									}}
									label="Email"
									placeholder="Email"
								/>
								<LoadingButton
									onClick={() => checkAuth(email)}
									loading={loading}
									loadingIndicator="Loading..."
									variant="outlined"
								>
									Submit
								</LoadingButton>
							</Stack>
						</form>
					</Box>
				</Box>
				<Box sx={{ p: 5 }} />
			</Container>
			{/* Dialog rendered here */}
			<AuthDialog
				openStatus={openDialog}
				onClose={handleDialogClose}
				name={name}
				email={email}
				message={reslutMessage}
				createUser={createUser}
				title={resultTitle}
			/>
		</div>
	);
}

export default Auth;
